import { useQuery } from 'react-query'
import { getCategoriesBySlug, getPosts } from 'src/@shared/service/cms-api'
import { Blog } from 'src/@shared/types/cms/blog'
import { GetCategoriesParams } from 'src/@shared/service/cms-api.types'

import { useInfiniteScroll } from '../../../@shared/hooks/useInfiniteScroll'

export default function useBlogList(initialCatArgs: GetCategoriesParams, search?: string, category?: string) {
    const { data: categories } = useQuery(['categories'], () => getCategoriesBySlug(initialCatArgs))

    const getMore = async (pageParam: number, slug: string | undefined) => {
        const args = { sort: 'position', limit: 15, page: pageParam, slug, state: 'published' }
        return await getPosts(args, categories ?? [])
    }

    const { list, isLoading, hasNextPage, fetchNextPage } = useInfiniteScroll<Blog>(
        ['posts', search ?? '', category ?? ''],
        getMore,
        category
    )
    const blogList = list as Blog[]

    return {
        blogList,
        isLoading,
        hasNextPage,
        fetchNextPage,
    }
}
